module.exports = __webpack_public_path__ + "static/img/4-sundray.a5b35315.png";